<div *ngIf="showNotification" class="notification-container">
  <div class="float-left">
    <img src="assets/images/maintenance_notification.png" alt="Maintenance" />
    <p>
      Scheduled Maintenance: <strong>AI Advisor</strong> will be unavailable on {{dateTimeText}}.
    </p>
  </div>
  <div class="float-right">
    <button mat-button color="accent" class="hide-btn" (click)="hideNotification()">Hide</button>
  </div>
</div>